import React, { Component } from "react";
import { Row, Col, Container, Navbar, Card } from "react-bootstrap";
import { connect } from "react-redux";
import ApiService from "../../_services/ApiService";
import ThemeService from "../../_services/ThemeService";
import Config from './../../_config/config'
import { getUnReadNotificationCount, checkNewNotificationsOnServer } from "./../../push-notification";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBell, faSignOutAlt, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import getPortlets from './../../_actions/dashboardActions';
import "./WriteAlongDashboard.css";
import Loader from './../../_components/loader/loader';
import avatar from './images/blank-avatar.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { portletConstants } from "../../_constants/portlet.constants";

class WriteAlongDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticker : null,
          };
    }

    componentDidMount() {
        this.studentTickerMessages();
    }

    routeChange(path, portletData) {
        localStorage.setItem('portlet', JSON.stringify(portletData));
        this.props.history.push({
            pathname: path,
            state: { portlet: portletData }
        });
    }

    showNotification() {
        let path = "/notification";
        this.props.history.push({
            pathname: path
        });
    }

    sliderButtonAction = (slide) => {
        let productId = slide.button.buttonAction.actionId;
        if (!Config.CURRENT_PORTLET && !JSON.parse(localStorage.getItem('portlet'))) {
            let portletConfig = {
                "id": productId,
                "class": "blue-card",
                "name": slide.title,
                "icon": "./assets/imgs/payment.png"
            }
            Config.CURRENT_PORTLET = portletConfig;
        }
        this.setState({ loading: true }, () => {
            ApiService.getProduct(productId)
                .then((res) => { //SuccessCB
                    let product = res.data.data;
                    this.props.setStateLoading(false);
                    this.props.history.push({
                        pathname: '/ProductDetails',
                        state: { product: product }
                    });
                },
                    error => {
                        console.log("Dashboard --> getProduct() -> Connection Error : " + Config.CONNECTION_ERROR);
                    });
        });
    }

    renderSlider(slider) {
        let settings = {
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <div>
                <Slider {...settings}>
                    {
                        slider.slides.map((slide, index) => {
                            return (
                                <div>
                                    <div className="mb-outer">
                                        <div className="mb-text-1">
                                            <h1>{slide.title}</h1>
                                            <h3>{slide.subTitle}</h3>
                                            {
                                                slide.button.enableStatus &&
                                                <a className="banner-button" href="#"
                                                    onClick={() => this.sliderButtonAction(slide)}
                                                    style={{ background: slide.button.buttonColor, color: slide.button.buttonTextColor }}>
                                                    {slide.button.buttonTitle}
                                                </a>
                                            }
                                        </div>
                                        <img src={slide.imageURL} />
                                    </div>
                                </div>
                            )
                        })
                    }
                </Slider>
            </div>
        );
    }


    renderAddToHome() {  //A2H
        return (
            <>
                {
                    this.props.showA2H && !this.props.isPWAInstalled &&
                    <div className="ilearn-footer">
                        <Row>
                            <Col className="ilearn-footer-col" >
                                <button className="btn ilearn-blue-btn ilearn-footer-btn btn-lg btn-block" >
                                    <img src="/logo192.png" alt="notification" className="float-left" style={{ width: '24px', height: '24px', float: 'left' }} />
                                    <span onClick={() => this.props.addToHome}>
                                        Add {(new URL(window.location)).hostname} to Home screen
                                    </span>
                                    <span onClick={() => this.props.closeAddToHome} className="float-right">
                                        <FontAwesomeIcon icon={faTimes} size='lg' color='#fff' />
                                        &nbsp;
                                    </span>
                                </button>
                            </Col>
                        </Row>
                    </div>
                }
            </>
        );
    }

    renderPortlets(portlets) {
        const renderAllPortlets = Object.keys(portlets).sort((a, b) => b.name - a.name).map((item, index) =>
            item != 'Marketplace' && <div>
        <div class= "title-card" style={portletConstants['Cards'][item]}><img src={portlets[item][0]['icon']}></img><span >{item}</span></div> 
      { this.renderWriteAlongPortlets(portlets, item) }</div >
    )
        return <div>{renderAllPortlets}</div>
    }

    render() {
        const { loading } = this.props;
        let user = JSON.parse(localStorage.getItem('user'));
        let data = this.props.dashboard.data;
        let slider = data?.slider || null;
        let isSliderEnable = slider ? slider.enableStatus : false;
        let portlets = {};
        if (typeof (data) !== 'undefined' || data != null) {
            data.portlets.sort((a,b) => a.id - b.id).map((portlet, index) => {
                if(portlet['target']!='profile') {
                    if (!portlets[portlet.tag]) portlets[portlet.tag] = [];
                        portlets[portlet.tag].push(portlet);
                }      
            })
        }

        return (
            <>
                <div className="writealongdashboard">
                    {this.renderHeader()}
                    <Container fluid>
                        <Row>
                            <Col xs={12} sm={9} md={9} >
                                <div className="user-name"> Hello, {user.enquiryName} </div> <br />
                                {isSliderEnable && <div className="slider-list">  {this.renderSlider(slider)} </div>}
                            </Col>
                            <Col xs={12} md={3}>
                                {<div className="market-place"> Marketplace {this.renderMarketPlacePortlets(portlets, 'Marketplace')} </div>}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={9} >
                                <div className="category-list"> <br />
                                    {
                                        loading ? <Loader /> : <div>{this.renderPortlets(portlets)}</div>
                                    }
                                    <br />
                                </div>
                            </Col>
                            <Col xs={12} md={3}>
                                <br />
                                <div className="market-place"> My notification </div> <br />
                                <div>
                                    {this.props.notificationCount != 0 ? <span>No new notifications to display </span> : this.renderNotifications()}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                {this.renderAddToHome()}

            </>
        );
    }

    renderNotifications() {
         const msgs = this.state.ticker
          const notifications = msgs && msgs.map((item, index) => 
                <div class = "notification-card">
                  <marquee direction = "up" scrollamount="1" class = "notification-description" dangerouslySetInnerHTML={{ __html:item}} /> 
                  </div>
              )
         return <Row> {notifications}</Row>
    }

    renderWriteAlongPortlets(portlets, item) {
        let data = this.props.dashboard.data;
        if (typeof (data) !== 'undefined' || data != null) {
            const renderPortlet =
                portlets[item].sort((a, b) => a.id - b.id)
                    .map((portlet, index) =>
                        portlet.isTile && <div key={index} className="col col-md-3 col-sm-3 col-xs-6 order-2">
                            <div class = "portlet card" style={portletConstants['Title'][item]}  onClick={() => this.routeChange(portlet.target == "studyResource" || portlet.target == "lessonPlan" ? portlet.target + '/' + portlet.params.resourceTypeId + '/' + portlet.params.resourceSubTypeId + '/' + portlet.name : portlet.target+'/', portlet)}>
                                <Card.Img variant="top" src={portlet.image} />
                                    <Card.Title> <img src={portlet.icon} alt="Messages" style={{ width: '34px', height: '34px',marginLeft:'8px' }} /><span className='marketplace-name'>{portlet.name}</span></Card.Title>
                            </div>
                        </div>
                    )
            return <Row> {renderPortlet} </Row>
        }
    }

    renderMarketPlacePortlets(portlets, item) {
        let data = this.props.dashboard.data;
        if (typeof (data) !== 'undefined' || data != null) {
            const renderPortlet =
                portlets[item].sort((a, b) => a.id - b.id)
                    .map((portlet, index) =>
                        portlet.isTile &&
                        <div class='marketplace-card ' onClick={() => this.routeChange(portlet.target == "studyResource" || portlet.target == "lessonPlan" ? portlet.target + '/' + portlet.params.resourceTypeId + '/' + portlet.params.resourceSubTypeId + '/' + portlet.name : portlet.target+'/', portlet)}>
                            <div class="marketplace-name">
                                <FontAwesomeIcon style={{ color: "#0063FF" }} icon={faShoppingCart} />
                                <span class="name">{portlet.name}</span></div>
                        </div>
                    )
            return <Row> {renderPortlet} </Row>
        }
    }

    studentTickerMessages() {
      
        ApiService.studentTickerMessages()
        .then((res) => { 
          console.log("ticker",res)
          this.setState({
            ticker: res.data.importantMessages
          });
        },
        error => { //ErrorCB
          console.log(Config.CONNECTION_ERROR);
        });
    }


    renderHeader() {
        let user = JSON.parse(localStorage.getItem('user'));
        var pic = "";
        if (user.photoPath) {
            pic = user.photoPath;
        } else {
            pic = avatar;
        }
        let siteTitle = localStorage.getItem('siteTitle') || (Config.siteTitle == "writealong" ? "i-EXPRESS" : Config.siteTitle);
        return (
            <Navbar sticky="top" style={{ background: '#FFFFFF', border: '1px solid #E0E0E0'}}> 
                <Navbar.Brand href="/"><img alt="" src={Config.logo} width="70" height="65" className="d-inline-block align-top" /></Navbar.Brand>
                <span class="site-name" >{siteTitle}</span>
                <Navbar.Toggle />
                <Navbar.Collapse className="justify-content-end">
                    <FontAwesomeIcon icon={faBell} onClick={() => this.showNotification()} />
                    {this.props.notificationCount > 0 ? <span class="notification_count">{this.props.notificationCount}</span> : '' }
                    <span class="divider"></span>
                    <Navbar.Text>
                        <span onClick={() => this.routeChange('profile', '')}><img src={pic} width='44' height='44' alt="profile" />{user.enquiryName}</span>
                    </Navbar.Text>
                    <FontAwesomeIcon icon={faSignOutAlt} onClick={() => this.routeChange('logout', "")} />
                </Navbar.Collapse>
            </Navbar> 
        )
    }


}


export default WriteAlongDashboard;